import { Alert, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { AuthLayout } from "@src/components/modules/auth/layout";
import { LoadingOverlay } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { getQueryParamOptional } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { type FunctionComponent, useEffect } from "react";

export const TwoFASetup: FunctionComponent = observer(function TwoFASetup() {
  const {
    authStore: { twoFactorAuthenticationStore },
  } = useStore();
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      twoFactorAuthenticationStore.initEnableStep(
        getQueryParamOptional("redirect_to", router.query),
      );
    }
  }, [router.isReady]);

  if (twoFactorAuthenticationStore.setupStatus === "error") {
    return (
      <AuthLayout>
        <Alert status="error">
          <Trans>
            Oops, an unexpected error happened. Please try refreshing the page.
          </Trans>
        </Alert>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <LoadingOverlay
        isLoading={twoFactorAuthenticationStore.setupStatus === "loading"}
        position="absolute"
      >
        <Flex align="start" direction="column" gap="4">
          <Heading as="h1" size="md">
            <Trans>Two-Factor Authentication Set Up</Trans>
          </Heading>
          <Text>
            <Trans>
              Your account is not secured with two-factor authentication.
              <br />
              We recommend enabling two-factor authentication to improve your
              account's security.
            </Trans>
          </Text>
          <Button
            isLoading={
              twoFactorAuthenticationStore.setupStatus === "submitting"
            }
            onClick={() => {
              twoFactorAuthenticationStore.enableTwoFactorAuthentication();
            }}
          >
            <Trans>Enable Two-Factor Authentication</Trans>
          </Button>
        </Flex>
      </LoadingOverlay>
    </AuthLayout>
  );
});
